export const SceneData = [
  {
    sceneNum : 0,
    sceneTitle : "You are a travelling with a trusted companion. You pass through a village when you" + 
    " realize the village is under attack by bandits!",
    choices : {
      choice0 : "You fight the bandits head-on",
      choice1 : "You negotiate with the bandits",
      choice2 : "You help organize the villagers into a fighting back",
      choice3 : "You decide to leave the village" 
    },
    aiPrompt : {
      choice0 : "fight the bandits head-on, risking your own safety to protect the villagers. ",
      choice1 : "negotiate with the bandits, offering them gold or valuables in exchange for sparing the village. ",
      choice2 : "help organize the villagers into a defensive strategy, using their knowledge of the terrain to their advantage. ",
      choice3 : "leave the village to avoid getting caught in the conflict, feeling that your safety is important to continue your journey and help others in the future. "
    }
  },
  {
    sceneNum : 1,
    sceneTitle : "A dying king has asked you to take a relic to a temple to ensure peace for his people. However the king’s reign was marked by cruelty.",
    choices : {
      choice0 : "You agree to take the relic for the greater good",
      choice1 : "You refuse the relic, because the king doesn't deserve it",
      choice2 : "You take the relic, but only if the kingdom proves their worth first",
      choice3 : "You hide the relic and do nothing, because you don't know what to do" 
    },
    aiPrompt : {
      choice0 : "agree to take the relic, believing that it’s the best course of action for the greater good. ",
      choice1 : "refuse the relic, feeling that the king’s actions don’t deserve to be honored. ",
      choice2 : "take the relic, but only if the people of the kingdom prove their worth and intentions first. ",
      choice3 : "hide the relic and take no action, unsure of what the best course of action is. "
    }
  },

  {
    sceneNum : 2,
    sceneTitle : "A hooded figure jumps out of the shadows and offers to reveal a prophecy about your future. However, the figure warns that the prophecy might be cryptc.",
    choices : {
      choice0 : "You accept the prophecy, intrigued by what it might reveal about your future",
      choice1 : "You decline the prophecy, preferring to shape your own destiny",
      choice2 : "You ask the figure for more clarification",
      choice3 : "You offer a bargain, hoping the figure will give you a clearer prophecy" 
    },
    aiPrompt : {
      choice0 : "accept the prophecy, intrigued by what it might reveal about your future. ",
      choice1 : "politely decline the prophecy, preferring to shape your own destiny without external guidance. ",
      choice2 : "ask the figure for more clarification, wanting to understand the potential impact of the prophecy before deciding. ",
      choice3 : "offer a bargain, hoping the figure will give you a clearer prophecy in exchange for something of value. "
    }
  },

  {
    sceneNum : 3,
    sceneTitle : "You found a cursed relic that promises great power, but comes with a curse that could harm you or others.",
    choices : {
      choice0 : "You take the relic, confident that you can manage the curse’s effects",
      choice1 : "You leave the relic behind, believing that the risk is too great",
      choice2 : "You destroy the relic, so no one else can be harmed",
      choice3 : "You give the relic to someone else, hoping they can handle it better" 
    },
    aiPrompt : {
      choice0 : "take the relic, confident that you can manage or mitigate the curse’s effects. ",
      choice1 : "leave the relic behind, believing that the risk is too great and the potential harm not worth the power. ",
      choice2 : "destroy the relic, ensuring that no one else can be harmed by its curse. ",
      choice3 : "give the relic to someone else, hoping they can handle it better or use it for good. "
    }
  },

  {
    sceneNum : 4,
    sceneTitle : "Your companion suddenly betrays you, taking all your supplies. You confront them at the next village, and they beg for your forgiveness, claiming they had no choice.",
    choices : {
      choice0 : "You forgive them, understanding that they acted out of necessity",
      choice1 : "You decide to part ways, feeling that trust is essential",
      choice2 : "You give them a chance to prove themselves, setting terms for their redemption",
      choice3 : "You continue your journey together, keeping an eye on their actions" 
    },
    aiPrompt : {
      choice0 : "forgive them, understanding that they acted out of necessity and giving them another chance. ",
      choice1 : "decide to part ways, feeling that trust is essential and cannot be easily restored. ",
      choice2 : "give them an opportunity to prove their loyalty again, setting clear terms for their redemption. ",
      choice3 : "You confront them, but choose to continue your journey together while keeping a watchful eye on their actions. "
    }
  },
];